<div class="-search-form-container">
    <input type="text" placeholder="Search Payrix"/>
    <icon icon="search" class="-xsm"></icon>
</div>